<!-- <p>pricing works!</p> -->
<div id="price-tables" class="page-layout simple fullwidth">

    <!-- HEADER -->
    <div class="header" fxLayout="row" fxLayoutAlign="start start">

        <div class="hero-text" fxLayout="column" fxLayoutAlign="center center" fxFlex>

            <div class="h1">Simple Pricing!</div>
            <div class="h3">
                Flexible pricing to fit your à la carte needs. Simple, bundled value in a unified plan!
            </div>

        </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content" fxLayout="column">

        <!-- PRICE TABLES -->
        <div class="price-tables" fxLayout="row wrap" fxLayoutAlign="center center">

            <div class="price-table style-2 mat-elevation-z4" 
            [class.selected]="selectedDiv === 'marketing'"
            (click)="selectDiv('marketing')"
            fxLayout="column" style="margin-right: -5px;">

                <div class="package-type mat-accent-fg" style="margin-top: -10px; margin-bottom: 10px;">Marketing
                    <!-- <p>Increase customer satisfaction with dedicated live chat & helpdesk tools</p> -->
                </div>

                <!-- <div class="price" fxLayout="row" fxLayoutAlign="center start">
                    <div class="currency">$</div>
                    <div class="value">99</div>
                </div>

                <div class="period">PER MONTH</div>

                <div class="terms" fxLayout="column" fxLayoutAlign="start center">
                    <div class="term">
                        <span class="text-bold">10</span>
                        Projects
                    </div>
                    <div class="term">
                        <span class="text-bold">10</span>
                        Pages
                    </div>
                    <div class="term">
                        <span class="text-bold">100</span>
                        Mb Disk Space
                    </div>
                </div>

                <button mat-raised-button class="cta-button" color="accent">GET STARTED</button>-->

            </div>

            <div class="price-table style-2 mat-elevation-z12"
            [class.selected]="selectedDiv === 'conversations'"
            (click)="selectDiv('conversations')" fxLayout="column">

                <!-- <div class="badge warn">BEST VALUE</div> -->

                <div class="package-type mat-accent-fg" style="margin-top: -10px; margin-bottom: 10px;">Conversations</div>

                <!-- <div class="price" fxLayout="row" fxLayoutAlign="center start">
                    <div class="currency">$</div>
                    <div class="value">299</div>
                </div>

                <div class="period">PER MONTH</div>

                <div class="terms" fxLayout="column" fxLayoutAlign="start center">
                    <div class="term">
                        <span class="text-bold">20</span>
                        Projects
                    </div>
                    <div class="term">
                        <span class="text-bold">20</span>
                        Pages
                    </div>
                    <div class="term">
                        <span class="text-bold">200</span>
                        Mb Disk Space
                    </div>
                </div>

                <button mat-raised-button class="cta-button" color="accent" (click)="onClickMe()">GET STARTED</button> -->

            </div>

            <!-- <div class="price-table style-2 mat-elevation-z4" fxLayout="column">

                <div class="package-type mat-accent-fg">PLATINUM PACKAGE</div>

                <div class="price" fxLayout="row" fxLayoutAlign="center start">
                    <div class="currency">$</div>
                    <div class="value">499</div>
                </div>

                <div class="period">PER MONTH</div>

                <div class="terms" fxLayout="column" fxLayoutAlign="start center">
                    <div class="term">
                        <span class="text-bold">40</span>
                        Projects
                    </div>
                    <div class="term">
                        <span class="text-bold">40</span>
                        Pages
                    </div>
                    <div class="term">
                        <span class="text-bold">500</span>
                        Mb Disk Space
                    </div>
                </div>

                <button mat-raised-button class="cta-button" color="accent">GET STARTED</button>-->

            <!-- </div> -->

        </div>








        <!-- / PRICE TABLES -->


        <div>



        <div class="css-10w03eq e6pt7mt0" style="padding-top: 64px;">

            <div class="css-lthdxc e6pt7mt1">
                <div class="css-1dapb4j e6pt7mt2">Monthly</div>
                <div class="css-1pkeq41 e6pt7mt2">
                    <div class="css-177zfpz e6pt7mt3">
                        <div font-weight ="500" class="css-lbzv0e eio1fiq0">2 months free</div>
                    </div>
                    "Anually"
                </div>
            </div>

        </div>



        <div class="css-1nfc9bp ejm7nno0">
            <div class="css-tvu4o0 ee3tq400">
                <div class="css-1l9pe81 edhhkg90">
                    <div class="css-16du36i edhhkg91">
                        <div>
                            <p color="default" font-weight="500" class="css-7togaz elbe5ih0">Free</p>
                            <p color="default" font-weight="400" class="css-19oe4ar elbe5ih0">
                            For new businesses seeking to start offering great customer service. Free forever. No credit card required.</p>
                        </div>

                    </div>

                    <p color="undued" font-weight = "400" cass="css-cp5qj4 elbe5ih0">&nbsp;</p>

                    <div class="css-yzh1nr edhhkg93"> 
                        <p color="default" font-weight="500" class="css-lnnlwy elbe5ih0">0</p>

                        <div>
                            <p color="default" font-weight="500" class="css-66g4ti elbe5ih0">USD</p>
                            <p color="default" font-weight="500" class="css-66g4ti elbe5ih0">/month</p>
                        </div>


                    </div>



                    <div class="css-1en8d0p e1tjowam0">
                        <div>
                             <div disabled="" class="css-1cp434n en8emvw0">
                                <div class="css-n0ccit en8emvw1">
                                    <div class="css-1uoquzc en8emvw3">
                                        <p color="disabled" font-weight="400" class="css-1nqqm6h elbe5ih0">50 Handled Conversations</p>
                                    </div>
                                    <div class="css-1iz8z0p en8emvw2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
                                            <path fill="#647491" fill-rule="evenodd" d="M5.834 8.334 10 12.5l4.167-4.166z" clip-rule="evenodd">

                                            </path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="css-19nb1hb en8emvw4">
                                    <ul class="css-12vnm1i en8emvw5">
                                        <li role="presentation" class="css-m9bxw6 en8emvw6">50 Handled Conversations</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="css-6pqkpu edhhkg95">
                        <a  type="button" font-weight="400" target="_self" class="css-14f2orh eykne1t0">Get started</a>
                        <p color="subdued" font-weight="400" class="css-tffpd8 elbe5ih0">&nbsp;</p>
                    </div>

                    <p color="default" font-weight="500" class="css-1dgujek elbe5ih0">This plan includes:</p>


                    <div class="css-1rr4qq7 eg2796v1">
                        <div class="css-11rk0im eg2796v0">
                            <img alt="icon check" loading="lazy" width="20" height="20" decoding="async" data-nimg="1" src="/images/icons/blue/pricing-checkmark.svg" style="color: transparent;">
                            <p color="default" font-weight="400" class="css-1bz2s1 elbe5ih0">Live chat</p>
                        </div>
                        <div class="css-11rk0im eg2796v0">
                            <img alt="icon check" loading="lazy" width="20" height="20" decoding="async" data-nimg="1" src="/images/icons/blue/pricing-checkmark.svg" style="color: transparent;">
                            <p color="default" font-weight="400" class="css-1bz2s1 elbe5ih0">Ticketing</p>
                        </div>
                        <div class="css-11rk0im eg2796v0"><img alt="icon check" loading="lazy" width="20" height="20" decoding="async" data-nimg="1" src="/images/icons/blue/pricing-checkmark.svg" style="color: transparent;">
                            <p color="default" font-weight="400" class="css-1bz2s1 elbe5ih0">Social media integrations</p>
                        </div>
                    </div>

                    <div class="css-wbud45 edhhkg94">
                        <a href="#all-features" type="button" font-weight="400" target="_self" class="css-47v3ae eykne1t0">See all features</a>
                    </div>




                </div>
                <div class="css-1l9pe81 edhhkg90">
                    <div class="css-16du36i edhhkg91">
                        <div>
                            <p color="default" font-weight="500" class="css-7togaz elbe5ih0">Free</p>
                            <p color="default" font-weight="400" class="css-19oe4ar elbe5ih0">
                            For new businesses seeking to start offering great customer service. Free forever. No credit card required.</p>
                        </div>

                    </div>

                    <p color="undued" font-weight = "400" cass="css-cp5qj4 elbe5ih0">&nbsp;</p>

                    <div class="css-yzh1nr edhhkg93"> 
                        <p color="default" font-weight="500" class="css-lnnlwy elbe5ih0">0</p>

                        <div>
                            <p color="default" font-weight="500" class="css-66g4ti elbe5ih0">USD</p>
                            <p color="default" font-weight="500" class="css-66g4ti elbe5ih0">/month</p>
                        </div>


                    </div>



                    <div class="css-1en8d0p e1tjowam0">
                        <div>
                             <div disabled="" class="css-1cp434n en8emvw0">
                                <div class="css-n0ccit en8emvw1">
                                    <div class="css-1uoquzc en8emvw3">
                                        <p color="disabled" font-weight="400" class="css-1nqqm6h elbe5ih0">50 Handled Conversations</p>
                                    </div>
                                    <div class="css-1iz8z0p en8emvw2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
                                            <path fill="#647491" fill-rule="evenodd" d="M5.834 8.334 10 12.5l4.167-4.166z" clip-rule="evenodd">

                                            </path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="css-19nb1hb en8emvw4">
                                    <ul class="css-12vnm1i en8emvw5">
                                        <li role="presentation" class="css-m9bxw6 en8emvw6">50 Handled Conversations</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="css-6pqkpu edhhkg95">
                        <a  type="button" font-weight="400" target="_self" class="css-14f2orh eykne1t0">Get started</a>
                        <p color="subdued" font-weight="400" class="css-tffpd8 elbe5ih0">&nbsp;</p>
                    </div>

                    <p color="default" font-weight="500" class="css-1dgujek elbe5ih0">This plan includes:</p>


                    <div class="css-1rr4qq7 eg2796v1">
                        <div class="css-11rk0im eg2796v0">
                            <img alt="icon check" loading="lazy" width="20" height="20" decoding="async" data-nimg="1" src="/images/icons/blue/pricing-checkmark.svg" style="color: transparent;">
                            <p color="default" font-weight="400" class="css-1bz2s1 elbe5ih0">Live chat</p>
                        </div>
                        <div class="css-11rk0im eg2796v0">
                            <img alt="icon check" loading="lazy" width="20" height="20" decoding="async" data-nimg="1" src="/images/icons/blue/pricing-checkmark.svg" style="color: transparent;">
                            <p color="default" font-weight="400" class="css-1bz2s1 elbe5ih0">Ticketing</p>
                        </div>
                        <div class="css-11rk0im eg2796v0"><img alt="icon check" loading="lazy" width="20" height="20" decoding="async" data-nimg="1" src="/images/icons/blue/pricing-checkmark.svg" style="color: transparent;">
                            <p color="default" font-weight="400" class="css-1bz2s1 elbe5ih0">Social media integrations</p>
                        </div>
                    </div>

                    <div class="css-wbud45 edhhkg94">
                        <a href="#all-features" type="button" font-weight="400" target="_self" class="css-47v3ae eykne1t0">See all features</a>
                    </div>




                </div>




                <div class="css-1l9pe81 edhhkg90">
                    <div class="css-16du36i edhhkg91">
                        <div>
                            <p color="default" font-weight="500" class="css-7togaz elbe5ih0">Standard</p>
                            <p color="default" font-weight="400" class="css-19oe4ar elbe5ih0">
                            For new businesses seeking to start offering great customer service. Free forever. No credit card required.</p>
                        </div>

                    </div>

                    <p color="undued" font-weight = "400" cass="css-cp5qj4 elbe5ih0">&nbsp;</p>

                    <div class="css-yzh1nr edhhkg93"> 
                        <p color="default" font-weight="500" class="css-lnnlwy elbe5ih0">0</p>

                        <div>
                            <p color="default" font-weight="500" class="css-66g4ti elbe5ih0">USD</p>
                            <p color="default" font-weight="500" class="css-66g4ti elbe5ih0">/month</p>
                        </div>


                    </div>



                    <div class="css-1en8d0p e1tjowam0">
                        <div>
                             <div disabled="" class="css-1cp434n en8emvw0">
                                <div class="css-n0ccit en8emvw1">
                                    <div class="css-1uoquzc en8emvw3">
                                        <p color="disabled" font-weight="400" class="css-1nqqm6h elbe5ih0">50 Handled Conversations</p>
                                    </div>
                                    <div class="css-1iz8z0p en8emvw2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
                                            <path fill="#647491" fill-rule="evenodd" d="M5.834 8.334 10 12.5l4.167-4.166z" clip-rule="evenodd">

                                            </path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="css-19nb1hb en8emvw4">
                                    <ul class="css-12vnm1i en8emvw5">
                                        <li role="presentation" class="css-m9bxw6 en8emvw6">50 Handled Conversations</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="css-6pqkpu edhhkg95">
                        <a (click)="onClickMe()" type="button" font-weight="400" target="_blank" class="css-14f2orh eykne1t0">Get started</a>
                        <p color="subdued" font-weight="400" class="css-tffpd8 elbe5ih0">&nbsp;</p>
                    </div>

                    <p color="default" font-weight="500" class="css-1dgujek elbe5ih0">This plan includes:</p>


                    <div class="css-1rr4qq7 eg2796v1">
                        <div class="css-11rk0im eg2796v0">
                            <img alt="icon check" loading="lazy" width="20" height="20" decoding="async" data-nimg="1" src="/images/icons/blue/pricing-checkmark.svg" style="color: transparent;">
                            <p color="default" font-weight="400" class="css-1bz2s1 elbe5ih0">Live chat</p>
                        </div>
                        <div class="css-11rk0im eg2796v0">
                            <img alt="icon check" loading="lazy" width="20" height="20" decoding="async" data-nimg="1" src="/images/icons/blue/pricing-checkmark.svg" style="color: transparent;">
                            <p color="default" font-weight="400" class="css-1bz2s1 elbe5ih0">Ticketing</p>
                        </div>
                        <div class="css-11rk0im eg2796v0"><img alt="icon check" loading="lazy" width="20" height="20" decoding="async" data-nimg="1" src="/images/icons/blue/pricing-checkmark.svg" style="color: transparent;">
                            <p color="default" font-weight="400" class="css-1bz2s1 elbe5ih0">Social media integrations</p>
                        </div>
                    </div>

                    <div class="css-wbud45 edhhkg94">
                        <a href="#all-features" type="button" font-weight="400" target="_self" class="css-47v3ae eykne1t0">See all features</a>
                    </div>




                </div>

            </div>

        </div>
    </div>

        <div class="faq" fxLayout="row wrap">

            <div class="title" fxFlex="100">Frequently Asked Questions</div>

            <div class="item" fxFlex="100" fxFlex.gt-xs="50">
                <div class="question">How does free trial work?</div>
                <div class="answer">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur a diam nec augue tincidunt
                    accumsan. In dignissim laoreet ipsum eu interdum.
                </div>
            </div>

            <div class="item" fxFlex="100" fxFlex.gt-xs="50">
                <div class="question">Can I cancel any time?</div>
                <div class="answer">
                    Aliquam erat volutpat. Etiam luctus massa ex, at tempus tellus blandit quis. Sed quis neque tellus.
                    Donec maximus ipsum in malesuada hendrerit.
                </div>
            </div>

            <div class="item" fxFlex="100" fxFlex.gt-xs="50">
                <div class="question">What happens after my trial ended?</div>
                <div class="answer">
                    Aliquam erat volutpat. Etiam luctus massa ex, at tempus tellus blandit quis. Sed quis neque tellus.
                    Donec maximus ipsum in malesuada hendrerit.
                </div>
            </div>

            <div class="item" fxFlex="100" fxFlex.gt-xs="50">
                <div class="question">Can I have a discount?</div>
                <div class="answer">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur a diam nec augue tincidunt
                    accumsan. In dignissim laoreet ipsum eu interdum.
                </div>
            </div>

        </div>

    </div>

</div>


